import { render } from "./ProductEditOld.vue?vue&type=template&id=c16d613e&scoped=true&ts=true"
import script from "./ProductEditOld.vue?vue&type=script&lang=ts"
export * from "./ProductEditOld.vue?vue&type=script&lang=ts"

import "./ProductEditOld.vue?vue&type=style&index=0&id=c16d613e&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c16d613e"]])

export default __exports__